import React from "react";
import { flexRender, type Row } from "@tanstack/react-table";

interface TableBodyProps {
  rows: Row<Record<string, any>>[];
}

export const TableBody: React.FC<TableBodyProps> = ({ rows }) => {
  return (
    <tbody className="divide-y divide-border-gray">
      {rows.map((row) => (
        <tr key={row.id} className="hover:bg-gray-50">
          {row.getVisibleCells().map((cell) => (
            <td
              key={cell.id}
              className="px-6 py-4 text-xs text-black border-b-2 border-r-2 border-border-gray"
              style={{ width: cell.column.getSize() }}
            >
              <div className="table-cell-content max-h-40 overflow-y-auto">
                {flexRender(cell.column.columnDef.cell, cell.getContext())}
              </div>
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
};
